/**
 * Featured Menu Module
 * Handles parallax scroll effect for featured menu items
 * Odd items translate upwards, even items translate downwards on scroll
 */

const featuredMenu = document.querySelector('.uecc-featured-menu');

if (featuredMenu) {
	const items = featuredMenu.querySelectorAll('.items .item');
	
	if (items.length > 0) {
		let ticking = false;
		const parallaxSpeed = 0.1; // Adjust this value to control parallax intensity
		const maxMovement = 50; // Maximum movement in pixels
		
		// Function to get initial positions
		const getInitialPositions = () => {
			const positions = [];
			items.forEach((item) => {
				// Reset transform temporarily to get accurate position
				const currentTransform = item.style.transform;
				item.style.transform = '';
				const rect = item.getBoundingClientRect();
				item.style.transform = currentTransform;
				positions.push({
					top: rect.top + window.scrollY,
					height: rect.height
				});
			});
			return positions;
		};
		
		let initialPositions = getInitialPositions();
		
		const handleParallax = () => {
			const scrollY = window.scrollY || window.pageYOffset;
			const windowHeight = window.innerHeight;
			const viewportCenter = scrollY + windowHeight / 2;
			const isMobile = window.innerWidth < 420;
			
			// If mobile, all items move in the same direction
			if (isMobile) {
				// Use the first item as reference for all items
				const firstInitial = initialPositions[0];
				if (!firstInitial) return;
				
				const columnCenter = firstInitial.top + firstInitial.height / 2;
				const distanceFromCenter = columnCenter - viewportCenter;
				const offset = distanceFromCenter * parallaxSpeed;
				
				// All items move up on mobile
				let translateY = -offset;
				translateY = Math.max(-maxMovement, Math.min(maxMovement, translateY));
				
				// Apply the same movement to all items
				items.forEach((item) => {
					item.style.transform = `translateY(${translateY}px)`;
				});
			} else {
				// Desktop: Group items by column (0 = left column, 1 = right column)
				const columnGroups = {
					0: [], // Left column: indices 0, 2, 4...
					1: []  // Right column: indices 1, 3, 5...
				};
				
				items.forEach((item, index) => {
					const column = index % 2;
					columnGroups[column].push({ item, index, initial: initialPositions[index] });
				});
				
				// Calculate movement for each column based on the first item in that column
				Object.keys(columnGroups).forEach((columnKey) => {
					const column = parseInt(columnKey);
					const columnItems = columnGroups[column];
					
					if (columnItems.length === 0) return;
					
					// Use the first item in the column as reference
					const firstItem = columnItems[0];
					const initial = firstItem.initial;
					if (!initial) return;
					
					// Calculate column center based on first item's initial position
					const columnCenter = initial.top + initial.height / 2;
					
					// Calculate distance from viewport center
					const distanceFromCenter = columnCenter - viewportCenter;
					
					// Calculate parallax offset
					const offset = distanceFromCenter * parallaxSpeed;
					
					// Left column (0) moves up, right column (1) moves down
					let translateY = column === 0 ? -offset : offset;
					
					// Clamp movement to maximum range
					translateY = Math.max(-maxMovement, Math.min(maxMovement, translateY));
					
					// Apply the same movement to all items in this column
					columnItems.forEach(({ item }) => {
						item.style.transform = `translateY(${translateY}px)`;
					});
				});
			}
			
			ticking = false;
		};
		
		const onScroll = () => {
			if (!ticking) {
				window.requestAnimationFrame(handleParallax);
				ticking = true;
			}
		};
		
		const onResize = () => {
			// Reset transforms and recalculate positions
			items.forEach((item) => {
				item.style.transform = '';
			});
			initialPositions = getInitialPositions();
			handleParallax();
		};
		
		// Initial calculation
		handleParallax();
		
		// Listen for scroll events
		window.addEventListener('scroll', onScroll, { passive: true });
		window.addEventListener('resize', onResize, { passive: true });
	}
}

